/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import EmailLink from '../../../../client/js/components/links/EmailLink'
import PhoneLink from '../../../../client/js/components/links/PhoneLink'
import SelectableRow from '../../../../client/js/components/selection/SelectableRow'
import { Badge, Table } from '@mantine/core'
import { getContactLink } from '../../lib/links/contactLinks'
import AnchorLink from '../../../../client/js/components/AnchorLink'

export type ContactListItemProps = {
  item: Contact
}

function ContactListItem (props: ContactListItemProps) {
  const intl = useIntl()
  const { item } = props
  return (
    <SelectableRow value={item.id}>
      <Table.Td>
        <AnchorLink to={getContactLink(item.id)}>
          {item.name}
        </AnchorLink>
      </Table.Td>
      <Table.Td>
        <PhoneLink phone={item.mobile} />
      </Table.Td>
      <Table.Td>
        <PhoneLink phone={item.phone} />
      </Table.Td>
      <Table.Td>
        <EmailLink email={item.email} />
      </Table.Td>
      <Table.Td>
        {item.enabled
          ? <Badge color="green">
            <FormattedMessage
              id="enabled"
              defaultMessage="Activé"
            />
          </Badge>
          : <Badge color="gray">
            <FormattedMessage
              id="disabled"
              defaultMessage="Désactivé"
            />
          </Badge>
        }
      </Table.Td>
      <Table.Td>
        {`${intl.formatDate(item.createdAt)} ${intl.formatTime(item.createdAt)}`}
      </Table.Td>
    </SelectableRow>
  )
}

export default ContactListItem
